<template>
	<article class="admin-list">
		<managing-section class="search-by-enter__container" :column-count="2">
			<managing-box title="이름">
				<input
					class="search-by-enter__target"
					type="text"
					v-model="nickName"
				/>
			</managing-box>
			<managing-box title="이메일">
				<input
					class="search-by-enter__target"
					type="text"
					v-model="eMail"
				/>
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button class="btn-main" type="button" @click="init">
				검색조건 초기화
			</button>
			<button class="btn-main blue" type="button" @click="searching">
				검색
			</button>
		</div>
		<managing-section :is-table="true">
			<template slot="infoSection">
				<div class="section__info__left">
					{{ this.getListStat }}
				</div>
				<div class="section__info__right">
					<select
						class="select section__info__items"
						@change="
							changeImmediately(
								'order',
								Number($event.target.value)
							)
						"
						:value="order"
					>
						<option
							v-for="item in orderList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
					<select
						class="select section__info__items"
						@change="
							changeImmediately(
								'limit',
								Number($event.target.value)
							)
						"
						:value="limit"
					>
						<option
							v-for="item in getLimitList()"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th v-for="th in thList" :key="th">{{ th }}</th>
					</tr>
				</thead>
				<tbody v-if="!adminList">
					<tr>
						<td :colspan="thList.length">불러오는중입니다.</td>
					</tr>
				</tbody>
				<tbody v-else-if="!adminList.length">
					<tr>
						<td :colspan="thList.length">리스트가 없습니다.</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr v-for="item in adminList" :key="item.id">
						<td>{{ item.idRegister }}</td>
						<td>
							<img
								class="admin-list__table__profile-img"
								:src="`${imgPath}${item.fileDir}/${item.fileSaveName}`"
								v-if="item.fileDir && item.fileSaveName"
							/>
						</td>
						<td>{{ getDepartment(item.department) }}</td>
						<td>{{ item.nickName }}</td>
						<td>{{ item.eMail }}<br />{{ item.userTel }}</td>
						<td>
							{{
								item.adminLevel
									? getItemById('adminLevel', item.adminLevel)
											.name
									: '-'
							}}
						</td>
						<td>{{ getLastDate(item.last_date) }}</td>
						<td>
							<button
								class="btn admin-list__otp-btn"
								type="button"
								@click="getOtp(item.eMail)"
							>
								OTP
							</button>
						</td>
						<td>
							<button
								class="btn orange admin-list__modify-btn"
								type="button"
								@click="modifyAdmin(item)"
							>
								수정
							</button>
						</td>
						<td>
							<template v-if="item.isActivity">
								Y
								<button
									class="btn red admin-list__withdrawal-btn"
									type="button"
									@click="
										changeActivity(
											false,
											item.idRegister,
											item.isActivity
										)
									"
								>
									탈퇴
								</button>
							</template>
							<template v-else>
								N
								<button
									class="btn blue admin-list__withdrawal-btn"
									type="button"
									@click="
										changeActivity(
											true,
											item.idRegister,
											item.isActivity
										)
									"
								>
									승인
								</button>
							</template>
						</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				v-if="isSupperAdmin && adminList && adminList.length > 0"
				@to="changeImmediately('offset', $event.offset)"
				:total-item="total"
				:limit="limit"
				:offset="offset"
				slot="pagination"
			/>
		</managing-section>
	</article>
</template>

<script>
	import moment from 'moment';
	import isEqual from 'lodash/isEqual';
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SortLabel from '@/components/product/SortLabel.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';

	export default {
		name: 'AdminList',
		components: { ManagingSection, ManagingBox, SortLabel, PaginationBox },
		extends: SearchByEnter,
		data() {
			return {
				nickName: '',
				eMail: '',
				orderList: [
					{ id: 0, name: '최신등록순' },
					{ id: 1, name: '이전등록순' },
					{ id: 2, name: '활동순' },
					{ id: 3, name: '비활동순' },
				],
				order: 0,
				limit: 10,
				offset: 0,
				thList: [
					'번호',
					'사진',
					'부서명',
					'관리자명',
					'연락처',
					'등급',
					'최근접속일',
					'보안',
					'수정',
					'활동여부',
				],
				total: 0,
				activity: 0,
				unActivity: 0,
				adminList: null,
			};
		},
		computed: {
			...mapState({
				imgPath: state => state.env.IMAGE_STORAGE_PATH,
				adminLevel: state => state.login.adminLevel,
				departmentList: state => state.filter.departmentList,
			}),
			...mapGetters(['getLimitList', 'getItemById']),
			getListStat() {
				return `등록: ${this.total}건 / 활성: ${this.activity}건 / 비활성: ${this.unActivity}건`;
			},
			isSupperAdmin() {
				return this.adminLevel === 1;
			},
		},
		mounted() {
			this.setFilter();
			this.getList();
		},
		methods: {
			init() {
				this.nickName = '';
				this.eMail = '';
			},
			changeImmediately(key, value) {
				this[key] = value;
				this.searching(key === 'offset' ? value : 0);
			},
			getDepartment(department) {
				if (!department) return '';
				return this.departmentList.find(item => item.id === department)
					.name;
			},
			getLastDate(date) {
				return date
					? moment(date, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm')
					: '';
			},
			setFilter() {
				const query = this.$route.query;
				let value;
				Object.keys(query).forEach(key => {
					value = query[key];
					if (value && this.hasOwnProperty(key)) {
						this[key] =
							key === 'nickName' || key === 'eMail'
								? value
								: Number(value);
					}
				});
			},
			setQuery() {
				const query = {
					offset: String(this.offset),
					limit: String(this.limit),
					order: String(this.order),
					nickName: this.nickName,
					eMail: this.eMail,
				};
				if (isEqual(query, this.$route.query)) return;
				this.$router.replace({ query });
			},
			async getList() {
				try {
					const params = {
						offset: this.offset,
						limit: this.limit,
						order: this.order,
						nickName: this.nickName,
						eMail: this.eMail,
					};
					const { data } = await this.$axiosSupport.get(
						'/admin/adminAccount',
						{ params }
					);
					this.adminList = data.list;
					this.total = data.total;
					this.activity = data.activity;
					this.unActivity = data.unActivity;
				} catch (err) {
					console.error(err);
					alert(
						'목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				} finally {
					this.setQuery();
				}
			},
			searching(offset) {
				this.offset = typeof offset === 'number' ? offset : 0;
				this.getList();
			},
			getOtp(email) {
				if (!email) {
					alert('이메일이 없습니다.');
					return;
				}
				this.$store.commit('modal/toggleModal', {
					id: 'AdminOtp',
					params: { email },
				});
			},
			modifyAdmin(obj) {
				this.$store.commit('modal/toggleModal', {
					id: 'AdminModify',
					params: { obj },
				});
			},
			async changeActivity(isActivity, idRegister, activity) {
				try {
					if (
						!confirm(
							`정말 ${isActivity ? '승인' : '탈퇴'}처리 하시겠습니까?`
						)
					)
						return;
					const adminAccount = { isActivity: activity === 1 ? 0 : 1 };
					const { data } = await this.$axiosSupport.put(
						`/admin/adminAccount/${idRegister}`,
						{ adminAccount }
					);
					window.location.reload();
				} catch (err) {
					console.error(err);
					alert(
						'활동여부를 변경하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
		},
	};
</script>

<style lang="scss">
	.admin-list__table__profile-img {
		width: 180px;
	}

	.admin-list__otp-btn,
	.admin-list__modify-btn,
	.admin-list__withdrawal-btn {
		margin: 0 auto;
	}

	.admin-list .admin-list__withdrawal-btn {
		display: block;
		margin-top: 6px;
	}
</style>
